import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  IdentifierArray,
  IdentifierRecord,
  WalletAccount,
} from '@wallet-standard/core';

import { getChainId } from 'modules/auth/actions/getChainId';

import { connect, selectConnect } from './actions/connect';
import { disconnect } from './actions/disconnect';
import { CONNECTION_CACHE_KEY } from './const';
import { getConnectedIotaProvider } from './utils/getConnectedIotaProvider';

export const iotaListener = createListenerMiddleware();
iotaListener.startListening({
  predicate: action => {
    return !!connect?.matchFulfilled(action);
  },

  effect: (() => {
    let unsubscribe: (() => void) | undefined;
    return (_action, api) => {
      api.cancelActiveListeners();

      if (unsubscribe) {
        unsubscribe();
        unsubscribe = undefined;
      }

      const provider = getConnectedIotaProvider();

      unsubscribe = provider
        .getWallet()
        .features[
          'standard:events'
        ].on('change', (data: { accounts: WalletAccount[]; chains: IdentifierArray; features: IdentifierRecord<unknown> }) => {
          const state = api.getState();
          const { data: connectionData } = selectConnect(
            state as Parameters<typeof selectConnect>[0],
          );

          const eventAccountData =
            connectionData &&
            data.accounts.find(item => item.address === connectionData.address);

          if (eventAccountData) {
            const currentWalletAccount = provider.getWalletAccount();
            provider.updateWalletAccount(eventAccountData.address);

            if (eventAccountData.chains[0] !== currentWalletAccount.chains[0]) {
              void api.dispatch(getChainId.initiate(undefined));
            }
          } else {
            if (!connectionData) {
              return;
            }

            const disconnectThunk = disconnect.initiate(
              { walletId: connectionData.walletId },
              {
                fixedCacheKey: CONNECTION_CACHE_KEY,
              },
            );

            const result = api.dispatch(disconnectThunk);
            result.reset();
          }
        });
    };
  })(),
});
